module.exports = __webpack_public_path__ + "static/img/yy15.673f536.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy15.png
// module id = wXQ3
// module chunks = 1